<template>
  <div
    class="telemetry-ots-parts"
    :class="[
      { 'telemetry-ots-parts--running-low': value < 20 },
      { 'telemetry-ots-parts--enabled': otsEnabled && value > 0 },
      { 'telemetry-ots-parts--disabled': otsDisabled },
    ]"
  >
    <svg
      v-if="otsEnabled && value > 0"
      class="telemetry-ots-parts__gauge__enabled__blink-light"
      width="215"
      height="442"
      viewBox="0 0 215 442"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient
          id="paint0_radial_808_13914"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(107.5 221) rotate(90) scale(221 107.5)"
        >
          <stop stop-color="#00FF47" />
          <stop offset="1" stop-color="#00FF47" stop-opacity="0" />
        </radialGradient>
      </defs>
      <!-- 画面右側 グラデーション点滅 -->
      <rect width="215" height="442" fill="url(#paint0_radial_808_13914)" />
    </svg>
    <div class="telemetry-ots-parts__header">
      <p class="telemetry-ots-parts__data">
        <span class="telemetry-ots-parts__number">{{ value }}</span>
        <sup class="telemetry-ots-parts__unit"><span>s</span></sup>
      </p>

      <p class="telemetry-ots-parts__label"><span>OTS</span></p>
    </div>

    <svg
      class="telemetry-ots-parts__gauge"
      width="144"
      height="25"
      viewBox="0 0 144 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- マスク: ゲージ全体 -->
      <clipPath id="telemetry-ots-parts__gauge__clip">
        <path
          d="M0 0H121.343C122.404 0 123.421 0.421427 124.172 1.17157L133 10H13.3137C11.192 10 9.15715 9.15715 7.65685 7.65685L0 0Z"
          fill="white"
        />
      </clipPath>

      <!-- マスク: ゲージ残量 -->
      <mask
        id="telemetry-ots-parts__gauge__clip2"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        width="160"
        height="14"
      >
        <rect :width="gaugeWidth" height="10" x="0" y="0" transform="skewX(45)" fill="white" />
      </mask>
      <!-- クリップパス: OTS ON時 ゲージ用 -->
      <clipPath id="telemetry-ots-parts__gauge__enabled-clip">
        <path
          fill="white"
          d="M0,0l121.4,0.1c1.1,0,2.1,0.4,2.8,1.2l17,16.9H21.5c-2.1,0-4.2-0.8-5.7-2.3L0,0z"
        />
      </clipPath>

      <!-- OTS ON時 下反射グラデーションマスク -->
      <mask
        id="gaugeReflectBarMask"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="256"
        height="10"
      >
        <path
          d="M0 0H121.343C122.404 0 123.421 0.421427 124.172 1.17157L133 10H13.3137C11.192 10 9.15715 9.15715 7.65685 7.65685L0 0Z"
          fill="url(#gaugeReflectMaskGradient)"
        />
      </mask>

      <defs>
        <!-- OTS ON時 ゲージ左端白グラデーション -->
        <linearGradient
          id="paint0_linear_804_13913"
          x1="2"
          y1="0"
          x2="21.5"
          y2="2.01711e-07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A2FFE8" />
          <stop offset="1" stop-color="#A1FFE8" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_804_13913"
          x1="2.5"
          y1="10.5"
          x2="21.5"
          y2="1.20132e-06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>

        <!-- OTS ON時 ゲージボトムボーダー -->
        <linearGradient
          id="paint0_linear_803_13886"
          x1="-18.6667"
          y1="12"
          x2="-18.6261"
          y2="14.5104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#98FFE6" stop-opacity="0.4" />
        </linearGradient>

        <!-- OTS ON時 ゲージボトムボーダー 左線光彩 -->
        <filter
          id="filter0_f_804_13902"
          x="0"
          y="0"
          width="42"
          height="32"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_804_13902" />
        </filter>
        <linearGradient
          id="paint0_linear_804_13902"
          x1="10"
          y1="4"
          x2="42"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFC1" stop-opacity="0.4" />
          <stop offset="0.526042" stop-color="#00FFC1" />
          <stop offset="1" stop-color="#00FFC1" stop-opacity="0.4" />
        </linearGradient>

        <!-- OTS ON時 下反射マスク用グラデーション -->
        <linearGradient
          id="gaugeReflectMaskGradient"
          x1="128"
          y1="0"
          x2="128"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.630208" />
        </linearGradient>

        <!-- OTS ON時 下反射アニメーショングラデーション -->
        <linearGradient
          id="gaugeReflectGradient"
          x1="0"
          y1="10"
          x2="246"
          y2="10"
          gradientUnits="userSpaceOnUse"
          spreadMethod="reflect"
        >
          <animate attributeName="x1" dur="2s" from="-100%" to="100%" repeatCount="indefinite" />
          <animate attributeName="x2" dur="2s" from="0%" to="200%" repeatCount="indefinite" />

          <stop offset="0" stop-color="#00FFBA" />
          <stop offset="0.25" stop-color="#00FFBA" stop-opacity="0.4" />
          <stop offset="0.50" stop-color="#00FFBA" />
          <stop offset="0.75" stop-color="#00FFBA" stop-opacity="0.4" />
          <stop offset="1" stop-color="#00FFBA" />
        </linearGradient>
      </defs>

      <!-- ゲージ背景 -->
      <path
        opacity="0.2"
        d="M7 0H128.343C129.404 0 130.421 0.421427 131.172 1.17157L140 10H20.3137C18.192 10 16.1571 9.15715 14.6569 7.65685L7 0Z"
        :fill="fillColor"
      />
      <!-- ゲージ下ライン -->
      <path
        opacity="0.3"
        d="M143 13H19.1421C16.49 13 13.9464 11.9464 12.0711 10.0711L2 0H0L11.364 11.364C13.0518 13.0518 15.341 14 17.7279 14H144L143 13Z"
        :fill="fillColor"
      />

      <!-- 残量ゲージ -->
      <g clip-path="url(#telemetry-ots-parts__gauge__clip)" transform="translate(7,0)">
        <g
          mask="url(#telemetry-ots-parts__gauge__clip2)"
          :transform="`translate(${gaugePositionX - 7}, 0)`"
        >
          <rect
            v-if="!otsEnabled"
            width="123"
            height="10"
            x="0"
            y="0"
            :fill="fillColor"
            transform="skewX(45)"
            opacity="0.8"
          />
          <rect
            v-else
            class="telemetry-ots-parts__gauge__enabled__animation"
            width="123"
            height="10"
            x="0"
            y="0"
            transform="skewX(45)"
            fill="url(#gaugeReflectGradient)"
          />
        </g>
      </g>

      <!-- OTS ON時 ゲージボトムボーダー 左線光彩 -->
      <g
        v-if="otsEnabled && value > 0"
        class="telemetry-ots-parts__gauge__enabled__left-shadow"
        filter="url(#filter0_f_804_13902)"
        :transform="`translate(${gaugePositionX - 16}, -13)`"
      >
        <path
          d="M8 8H14.6863C16.808 8 18.8429 8.84285 20.3431 10.3431L34 24H27.3137C25.192 24 23.1571 23.1571 21.6569 21.6569L8 8Z"
          fill="url(#paint0_linear_804_13902)"
        />
      </g>

      <g
        v-if="otsEnabled && value > 0"
        transform="translate(-0.6,-8.2)"
        clip-path="url(#telemetry-ots-parts__gauge__enabled-clip)"
      >
        <!-- マスク: OTS ON時 ゲージボトムボーダー -->
        <path
          :transform="`translate(${gaugePositionX - 1}, 6.2)`"
          d="M4.17157 1.17157C3.42143 0.421427 2.40401 0 1.34315 0H0L10.8284 10.8284C11.5786 11.5786 12.596 12 13.6569 12H136.5L135.5 11H14.8284C14.298 11 13.7893 10.7893 13.4142 10.4142L4.17157 1.17157Z"
          fill="url(#paint0_linear_803_13886)"
        />
        <!-- OTS ON時 ゲージ左 白グラデーション -->
        <g
          class="telemetry-ots-parts__gauge__enabled__left-gradient"
          :transform="`translate(${gaugePositionX + 0.8},8.2)`"
        >
          <path
            d="M0 0H19.6863C21.808 0 23.8429 0.842855 25.3431 2.34315L33 10H13.3137C11.192 10 9.15715 9.15715 7.65685 7.65685L0 0Z"
            fill="url(#paint0_linear_804_13913)"
          />
          <path
            d="M0 0H19.6863C21.808 0 23.8429 0.842855 25.3431 2.34315L33 10H13.3137C11.192 10 9.15715 9.15715 7.65685 7.65685L0 0Z"
            fill="url(#paint1_linear_804_13913)"
          />
          <path
            d="M0 0H19.6863C21.808 0 23.8429 0.842855 25.3431 2.34315L33 10H13.3137C11.192 10 9.15715 9.15715 7.65685 7.65685L0 0Z"
            fill="url(#paint1_linear_804_13913)"
          />
        </g>
      </g>
      <!-- OTS ON時 下反射アニメーションバー   -->
      <g
        v-if="otsEnabled && value > 0"
        mask="url(#telemetry-ots-parts__gauge__clip)"
        transform="scale(1,-1) translate(8,-27)"
        opacity="0.5"
      >
        <g mask="url(#gaugeReflectBarMask)">
          <g
            mask="url(#telemetry-ots-parts__gauge__clip2)"
            :transform="`translate(${gaugePositionX - 7},0)`"
          >
            <rect
              width="123"
              height="10"
              x="0"
              y="0"
              transform="skewX(45)"
              fill="url(#gaugeReflectGradient)"
            />
          </g>
        </g>
      </g>
    </svg>

    <p v-if="otsDisabled" class="telemetry-ots-parts__disabled-time">
      <svg
        class="telemetry-ots-parts__disabled-time__icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5 9C14.5 12.0376 12.0376 14.5 9 14.5C7.75165 14.5 6.60043 14.0841 5.67736 13.3833L13.3833 5.67736C14.0841 6.60043 14.5 7.75165 14.5 9ZM4.6167 12.3226L12.3226 4.6167C11.3996 3.9159 10.2484 3.5 9 3.5C5.96243 3.5 3.5 5.96243 3.5 9C3.5 10.2484 3.9159 11.3996 4.6167 12.3226ZM16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z"
          fill="#FFB800"
        />
      </svg>

      <span class="telemetry-ots-parts__disabled-time__data">
        <span class="telemetry-ots-parts__number">{{ otsDisabledTime }}</span>
        <sup class="telemetry-ots-parts__unit"><span>s</span></sup>
      </span>
    </p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー オーバーテイク残時間 値パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryOtsParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    /**
     * オーバーテイクシステム有効フラグ
     */
    otsEnabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    /**
     * オーバーテイクシステム無効残時間
     */
    otsDisabledTime: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    const { adjustPosition } = useTelemetrySectionUtil()

    // 位置指定を整数化
    adjustPosition('.telemetry-ots-parts')

    // ゲージ横幅
    const gaugeSvgWidth = 123

    /**
     * gaugeWidth
     * ゲージの横幅を算出
     */
    const gaugeWidth = computed(() => (gaugeSvgWidth * props.value) / 200)

    /**
     * gaugePositionX
     * ゲージのX位置を算出
     */
    const gaugePositionX = computed(() => gaugeSvgWidth - (gaugeSvgWidth * props.value) / 200 + 7)

    /**
     * SVGカラー
     * 残秒数が一定以下時に赤へ変更
     */
    const fillColor = computed(() => (props.value > 20 ? '#fff' : '#ff2e00'))

    /**
     * オーバーテイクシステム無効状態判定
     */
    const otsDisabled = computed(() => props.otsDisabledTime > 0)

    return {
      gaugeWidth,
      gaugePositionX,
      fillColor,
      otsDisabled,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
@keyframes countdownBlink {
  0%,
  100% {
    opacity: 0;
  }

  25%,
  75% {
    opacity: 1;
  }
}
@keyframes enabledLeftShadowBlink {
  0%,
  100% {
    opacity: 0.5;
  }

  25%,
  75% {
    opacity: 1;
  }
}
@keyframes enabledTransition {
  0% {
    transform: translateX(-75%) skewX(45deg);
  }

  100% {
    transform: translateX(-25%) skewX(45deg);
  }
}
@keyframes enabledReflectTransition {
  0% {
    transform: translateX(-75%) skewX(-45deg);
  }

  100% {
    transform: translateX(-25%) skewX(-45deg);
  }
}

.telemetry-ots-parts {
  position: absolute;
  top: calc(min(4.2667vw, 1.333em) + 25.5em);
  right: 2em;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  justify-content: space-between;
  width: 12em;
  color: #fff;

  &--running-low {
    color: $red-light;
  }

  &--disabled {
    .telemetry-ots-parts__data,
    .telemetry-ots-parts__gauge {
      opacity: 0.3;
    }
  }

  &--enabled {
    color: $green-light;

    .telemetry-ots-parts__label {
      padding-right: 0;
      font-weight: 600;

      span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 3em;
        height: 1.5em;
        text-align: center;
        color: $black;
        background: $green-light;
        margin-bottom: -0.2em;
      }
    }
  }

  &__header {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 0.45em;
    line-height: 1;
  }

  &__data {
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    white-space: nowrap;
  }

  &__number {
    font-size: 1.5em;
    letter-spacing: 0.02em;
  }

  &__unit {
    display: inline-block;
    margin-left: 0.2em;
    font-size: 0.91667em;
    font-weight: 500;
    opacity: 0.5;

    span {
      display: inline-block;
      font-size: max(1em, 8px);
      transform: translateY(-20%);
    }
  }

  &__label {
    display: inline-block;
    padding: 0 0.333em 0 0;
    margin-right: 0.67em;
    letter-spacing: 0.08em;
    line-height: 1.1;
    background: transparent;
    color: rgba(255, 255, 255, 80%);
    transition: all ease 0.2s;

    span {
      font-size: max(1em, 8px);
      border-radius: 2px;
    }
  }

  &__gauge {
    overflow: visible;
    width: 100%;

    * {
      transition: width linear 1s;
    }

    &__enabled {
      &__left-gradient,
      &__left-shadow {
        animation: 0.5s linear enabledLeftShadowBlink infinite;
      }

      &__blink-light {
        position: absolute;
        top: -28em;
        left: -2em;
        width: 17.916em;
        height: auto;
        animation: 0.5s linear enabledLeftShadowBlink infinite;
      }
    }
  }

  &__disabled-time {
    position: absolute;
    right: 0;
    top: 1.74em;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;
    padding: 0 0.667em;

    &__data {
      animation: 1s ease-in-out countdownBlink infinite;
    }

    .telemetry-ots-parts__unit {
      color: #ffb800;
      opacity: 1;
      transform: translateY(0);
    }

    .telemetry-ots-parts__number {
      display: inline-block;
      min-width: 2.22em;
      color: #ffb800;
      text-align: right;
    }

    &__icon {
      width: 1.5em;
      height: 1.5em;
      opacity: 0.5;
    }
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-ots-parts {
      right: 1em;
      width: 13em;

      &__number {
        font-size: 1.55em;
      }

      &__unit {
        font-size: 0.91667em;

        span {
          font-size: 1.125em;
        }
      }

      &__label {
        span {
          font-size: 1.125em;
        }
      }
    }
  }
}
</style>
